import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { publicApi } from "../services/api";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CloseIcon from "@mui/icons-material/Close";

const EmailVerificationBanner: React.FC = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified || user.is_superadmin || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await publicApi.resendVerificationEmail();
      setSent(true);
    } catch {
      // Silently fail -- toast could be added if needed
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="yellow-banner !border-t-0">
      <MailOutlineIcon style={{ fontSize: 18 }} />
      <span>
        {sent
          ? "Verification email sent! Check your inbox."
          : "Please verify your email address. Check your inbox for a verification link."}
      </span>
      {!sent && (
        <button
          onClick={handleResend}
          disabled={sending}
          style={{
            background: "none",
            border: "none",
            color: "#6d28d9",
            fontWeight: 600,
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: 14,
            padding: 0,
          }}
        >
          {sending ? "Sending..." : "Resend email"}
        </button>
      )}
      <button
        onClick={() => setDismissed(true)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 4,
          position: "absolute",
          right: 12,
          color: "#92400e",
          opacity: 0.6,
        }}
        aria-label="Dismiss"
      >
        <CloseIcon style={{ fontSize: 16 }} />
      </button>
    </div>
  );
};

export default EmailVerificationBanner;
